/* =========================================================================
   SENİN KUTUM — Hero Slider davranışı
   Carousel + autoplay + fade/zoom (Ken Burns) geçiş + manuel reset.
   ========================================================================= */
(function () {
  'use strict';
  if (customElements.get('sk-hero')) return;

  class SkHero extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.dots = [];
      this.index = 0;
      this.timer = null;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-sk-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-sk-hero-dot]'));
      this.prevBtn = this.querySelector('[data-sk-hero-prev]');
      this.nextBtn = this.querySelector('[data-sk-hero-next]');
      this.speed = (parseFloat(this.getAttribute('data-autoplay')) || 6) * 1000;

      if (this.slides.length <= 1) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1, true));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(parseInt(dot.getAttribute('data-sk-hero-dot'), 10), true);
        });
      });

      // Klavye erişilebilirlik
      this.setAttribute('tabindex', '0');
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
        if (e.key === 'ArrowRight') this.go(this.index + 1, true);
      });

      // Fare üstündeyken duraklat
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());

      // İlk slaydın zoom animasyonunu başlat
      this.activateZoom(this.slides[0]);
      this.start();
    }

    disconnectedCallback() { this.stop(); }

    go(next, userInitiated) {
      var total = this.slides.length;
      var newIndex = ((next % total) + total) % total;
      if (newIndex === this.index) return;

      var current = this.slides[this.index];
      var target = this.slides[newIndex];

      // Fade out eski, fade in yeni
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');
      this.resetZoom(current);

      target.removeAttribute('hidden');
      // reflow tetikle ki transition çalışsın
      void target.offsetWidth;
      target.classList.add('is-active');
      target.setAttribute('aria-hidden', 'false');
      this.activateZoom(target);

      var self = this;
      setTimeout(function () {
        current.classList.remove('is-active', 'is-leaving');
        current.setAttribute('hidden', '');
      }, 700);

      this.index = newIndex;
      this.updateDots();

      if (userInitiated) { this.stop(); this.start(); }
    }

    activateZoom(slide) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var img = slide.querySelector('.sk-hero__img');
      if (img) img.classList.add('is-zooming');
    }
    resetZoom(slide) {
      var img = slide.querySelector('.sk-hero__img');
      if (img) img.classList.remove('is-zooming');
    }

    updateDots() {
      this.dots.forEach((dot, i) => {
        var active = i === this.index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    start() {
      this.stop();
      var self = this;
      this.timer = setInterval(function () {
        self.go(self.index + 1, false);
      }, this.speed);
    }
    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  }

  customElements.define('sk-hero', SkHero);
})();
